(function () {
    "use strict";

    angular
        .module("gatewayApp")

        .controller("ForgotPIDController", ForgotPIDController);

    ForgotPIDController.$inject = [
        "$scope",
        "$state",
        "$uibModalInstance",
        "workflowSharedService",
        "User",
        "GlobalValues",
        "EntityPermissions",
        "$filter",
        "entity",
        "ScreenLog",
        "$rootScope",
        "AlertService",
        "globalValue",
        "CryptoUtil"
    ];

    function ForgotPIDController(
        $scope,
        $state,
        $uibModalInstance,
        workflowSharedService,
        User,
        GlobalValues,
        EntityPermissions,
        $filter,
        entity,
        ScreenLog,
        $rootScope,
        AlertService,
        globalValue,
        CryptoUtil
    ) {
        var vm = this;

        vm.todayDate = new Date();
        vm.globalValues = GlobalValues;
        vm.getPID = getPID;
        vm.getPIDFromList = getPIDFromList;
        vm.NotFound = "No data found";
        vm.show = false;
        $scope.clicked = false;
        vm.clear = clear;
        vm.sendOTP = sendOTP;
        $scope.noOfRecordsPerPage =
            GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.mobileCountryCode = 91;
        vm.disableGenerateOTP = false;
        vm.resendPrimaryOTP = resendPrimaryOTP;
        vm.platformENCCode = "tV1f3EtXyUjBrf8JbbW7bSYf7JgyxZpVXYJvwAyM34Q=";
        vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;


        $scope.otpInput = {
            size: globalValue.defaultOTPLength,
            type: "password",
            onDone: function (value) {
                vm.otp = value;
            },
            onChange: function (value) {
                console.log(value);
            }
        };

        function getPID() {
            vm.PID = null;
            //var dob=$filter('date')(vm.dob, "yyyy-MM-dd");

            /*if(vm.aadharNumber==undefined || vm.aadharNumber==null){
                User.getPID({"firstName":vm.firstName,"dob":dob,"aadhar":'0'},onGetPIDSuccess,onGetPIDError);
            }
            else{
                User.getPID({"firstName":vm.firstName,"dob":dob,"aadhar":vm.aadharNumber},onGetPIDSuccess,onGetPIDError);
            }*/
            User.getPID(
                {
                    email: vm.email,
                    mobile: vm.mobile,
                    mobileCountryCode: vm.mobileCountryCode,
                    otp: vm.otp
                },
                onGetPIDSuccess,
                onGetPIDError
            );

            //User.getPID({"email":vm.email,"mobile":vm.mobile},onGetPIDSuccess,onGetPIDError);
        }

        $scope.selectedRow = null; // initialize our variable to null
        $scope.setClickedRow = function (index) {
            //function that sets the value of selectedRow to current index
            $scope.selectedRow = index;
        };

        function getPIDFromList(index) {
            vm.PID = vm.pidList[index].personDetails.personId;
            $rootScope.PID = vm.PID;
            $scope.$emit("fetchPID");
            $uibModalInstance.dismiss("cancel");
        }

        function onGetPIDSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            if (result.length == 1) {
                vm.PID = result[0].personDetails.personId;
                $rootScope.PID = vm.PID;
                $scope.$emit("fetchPID");
                $uibModalInstance.dismiss("cancel");
            } else if (result.length > 1) {
                vm.pidList = result;
            }
        }
        function onGetPIDError() {
            vm.wrongOTPAttemptCount = vm.wrongOTPAttemptCount + 1;
            if (
                vm.wrongOTPAttemptCount >=
                globalValue.maximumOTPWrongAttemptCount
            ) {
                //AlertService.error("Maximum wrong OTP attempt count is exceeded!<br>Please request for resend OTP.")
                MessageBox.openMessageBox(
                    "Alert",
                    "Maximum wrong OTP attempt count is exceeded! Session expired. You will be redirected to login page...!",
                    "Ok",
                    "invalidotpchangemobile"
                );
            }
            vm.otpClicked = false;
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        // function sendOTP() {
        // 	vm.disableGenerateOTP= true;
        // 		User.SendOTPSMS({
        // 			"mobile" :vm.mobile,
        // 			"mobileCountryCode": vm.mobileCountryCode,
        // 		}, onOTPSendSuccess, onSendOTPError);
        // 	}

        function sendOTP() {
            vm.disableGenerateOTP = true;
            if (vm.entityOwnerType != 'Clearcorp') {
                // ✅ Step 1: Execute reCAPTCHA
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // ✅ Step 2: Call API with token
                            User.SendOTPSMS(
                                {
                                    mobile: vm.mobile,
                                    mobileCountryCode: vm.mobileCountryCode,
                                    recaptchaToken: token,
                                    orgType: vm.entityOwnerType,
                                    sourceType: "send-otp",
                                    source: "forget-pid"
                                },
                                onOTPSendSuccess,
                                onSendOTPError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                            vm.disableGenerateOTP = false; // re-enable button
                        });
                });
            } else {
                User.SendOTPSMS(
                    {
                        mobile: vm.mobile,
                        mobileCountryCode: vm.mobileCountryCode,
                        orgType: vm.entityOwnerType,
                        sourceType: "send-otp",
                        source: "forget-pid"
                    },
                    onOTPSendSuccess,
                    onSendOTPError
                );

            }
        }
        function onOTPSendSuccess(result) {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = 0;
            AlertService.info("OTP has been sent to your mobile");
            vm.isOTPSend = true;
        }

        function onSendOTPError() {
            vm.disableGenerateOTP = false;
            AlertService.error("Error occurred while generating OTP mobile");
        }
    }

    function resendPrimaryOTP() {
        if (vm.mobileCountryCode == null || vm.mobileCountryCode == undefined) {
            vm.mobileCountryCode = "";
        }
        var mobileNo = vm.mobile;
        var mobileCountryCode = vm.mobileCountryCode;
        if (
            vm.resendOTPAttemptCount >= globalValue.maximumOTPResendAttemptCount
        ) {
            //AlertService.error("Maximum request for resend OTP is exceeded!<br>Please try again later.")
            MessageBox.openMessageBox(
                "Alert",
                "Maximum request for resend OTP is exceeded! Please try again.",
                "Ok",
                "resendotpchangemobile"
            );
            // }else{
            // 	User.SendOTPSMS({mobile: mobileNo, mobileCountryCode : mobileCountryCode}, onResendPrimaryOTPSuccess, onResendPrimaryOTPError);
            // }
        } else {
            if (vm.entityOwnerType != 'Clearcorp') {
                // ✅ Step 1: Execute reCAPTCHA
                grecaptcha.ready(function () {
                    grecaptcha
                        .execute(CryptoUtil.decrypt(vm.globalValues.getRecaptchaToken().recaptchaSiteKey, vm.platformENCCode), {
                            action: "otp_action"
                        })
                        .then(function (token) {
                            // ✅ Step 2: Call API with token
                            User.SendOTPSMS(
                                {
                                    mobile: mobileNo,
                                    mobileCountryCode: mobileCountryCode,
                                    orgType: vm.entityOwnerType,
                                    recaptchaToken: token,
                                    sourceType: "resend-otp",
                                    source: "forget-pid"
                                },
                                onResendPrimaryOTPSuccess,
                                onResendPrimaryOTPError
                            );
                        })
                        .catch(function (error) {
                            console.error("reCAPTCHA error:", error);
                            vm.disableGenerateOTP = false;
                        });
                });
            } else {
                User.SendOTPSMS(
                    {
                        mobile: mobileNo,
                        mobileCountryCode: mobileCountryCode,
                        orgType: vm.entityOwnerType,
                        sourceType: "resend-otp",
                        source: "forget-pid"
                    },
                    onResendPrimaryOTPSuccess,
                    onResendPrimaryOTPError
                );

            }
        }
        }

        function onResendPrimaryOTPSuccess() {
            vm.wrongOTPAttemptCount = 0;
            vm.resendOTPAttemptCount = vm.resendOTPAttemptCount + 1;
            AlertService.info("OTP has been resent to your mobile");
        }

        function onResendPrimaryOTPError() {
            //AlertService.error("Error occurred while generating OTP mobile");
        }
    }) ();
